import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/images/EH-logo.svg';

export default function Header({ scrollToSection, activeSection, isHomePage = true }) {
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="hover:opacity-70 transition-opacity">
            <img src={logo} alt="EH Logo" className="h-10 w-auto" />
          </Link>
          
          {isHomePage && location.pathname === '/' ? (
            // Navigation for home page with scroll
            <div className="flex gap-5">
              {['home', 'about', 'work', 'contact'].map((item) => (
                <button
                  key={item}
                  onClick={() => scrollToSection(item)}
                  className={`text-sm uppercase tracking-wider transition-colors ${
                    activeSection === item ? 'text-gray-900' : 'text-gray-400 hover:text-gray-600'
                  }`}
                >
                  {item}
                </button>
              ))}
            </div>
          ) : (
            // Back button for other pages
            <Link 
              to="/" 
              className="text-sm uppercase tracking-wider text-gray-600 hover:text-gray-900 transition-colors"
            >
              ← Back to Home
            </Link>
          )}
        </div>
      </div>
    </nav>
  );
}